<template>
  <BaseRadioSelector
    v-model="model"
    :items="accountOptions"
    :label="$t('account_type_radio_selector.accounts')"
    :medium="medium"
  />
</template>

<script lang="ts" setup>
import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import BaseRadioSelector from "shared/components/selectors/radio/BaseRadioSelector.vue";

const props = defineProps({
  medium: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Boolean,
  },
  disabled: {
    type: Boolean,
  },
});

const model = defineModel<boolean>();

const accountOptions = computed(() => [
  {
    id: false,
    name: getLocaleText("account_type_radio_selector.all_accounts"),
    disabled: props.disabled,
  },
  {
    id: true,
    name: getLocaleText("account_type_radio_selector.verified_accounts"),
    disabled: props.disabled,
  },
]);
</script>
